import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row fit no-wrap justify-end",
  style: {"overflow":"auto","gap":"20px"}
}

import BtnCancelFocusedInstitutional from '../actionButtons/BtnCancelFocusedInstitutional.vue'
import BtnViewInstitutionalDistribution from '../actionButtons/BtnViewInstitutionalDistribution.vue'
import BtnCancelCreateNewInstitutional from '../actionButtons/BtnCancelCreateNewInstitutional.vue'
import BtnEditFocusedInstitutional from '../actionButtons/BtnEditFocusedInstitutional.vue'
import BtnReviewFocusedInstitutional from '../actionButtons/BtnReviewFocusedInstitutional.vue'
import BtnSendFocusedInstitutionalToApprove from '../actionButtons/BtnSendFocusedInstitutionalToApprove.vue'
import BtnResendFocusedInstitutionalToApprove from '../actionButtons/BtnResendFocusedInstitutionalToApprove.vue'
import BtnApproveFocusedInstitutional from '../actionButtons/BtnApproveFocusedInstitutional.vue'
import BtnPublishFocusedInstitutional from '../actionButtons/BtnPublishFocusedInstitutional.vue'
import BtnBackEdit from '@/components/campaign/actionButtons/BtnBackEdit.vue'
import BtnDiscardChanges from '../actionButtons/BtnDiscardChanges.vue'
import BtnDeleteSelectedInstitutional from '../actionButtons/BtnDeleteSelectedInstitutional.vue'
import BtnRequestAdjustmentsToFocusedInstitutional from '../actionButtons/BtnRequestAdjustmentsToFocusedInstitutional.vue'
import BtnSaveFocusedInstitutional from '../actionButtons/BtnSaveFocusedInstitutional.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'InstitutionalActionButtonsSection',
  props: {
  propShowBtnBackEdit: { type: Boolean, required: false, default: false },
  propShowBtnCancelFocusedInstitutional: { type: Boolean, required: false, default: false },
  propShowBtnCancelCreateNewCampaign: { type: Boolean, required: false, default: false },
  propShowBtnEditFocusedInstitutional: { type: Boolean, required: false, default: false },
  propShowBtnDiscardChanges: { type: Boolean, required: false, default: false },
  propShowBtnSaveFocusedInstitutional: { type: Boolean, required: false, default: false },
  propShowBtnDeleteSelectedCampaigns: { type: Boolean, required: false, default: false },
  propShowBtnReviewFocusedCampaign: { type: Boolean, required: false, default: false },
  propShowBtnRequestAdjustmentsToFocusedInstitutional: { type: Boolean, required: false, default: false },
  propShowBtnSendFocusedInstitutionalToApprove: { type: Boolean, required: false, default: false },
  propShowBtnResendFocusedInstitutionalToApprove: { type: Boolean, required: false, default: false },
  propShowBtnApproveFocusedInstitutional: { type: Boolean, required: false, default: false },
  propShowBtnPublishFocusedInstitutional: { type: Boolean, required: false, default: false },
  propShowBtnViewCampaignDistribution: { type: Boolean, required: false, default: false },
  accordionRef: { type: Object, required: false, default: null }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.propShowBtnBackEdit)
      ? (_openBlock(), _createBlock(BtnBackEdit, { key: 0 }))
      : _createCommentVNode("", true),
    (props.propShowBtnCancelFocusedInstitutional)
      ? (_openBlock(), _createBlock(BtnCancelFocusedInstitutional, { key: 1 }))
      : _createCommentVNode("", true),
    (props.propShowBtnCancelCreateNewCampaign)
      ? (_openBlock(), _createBlock(BtnCancelCreateNewInstitutional, { key: 2 }))
      : _createCommentVNode("", true),
    (props.propShowBtnEditFocusedInstitutional)
      ? (_openBlock(), _createBlock(BtnEditFocusedInstitutional, { key: 3 }))
      : _createCommentVNode("", true),
    (props.propShowBtnDiscardChanges)
      ? (_openBlock(), _createBlock(BtnDiscardChanges, { key: 4 }))
      : _createCommentVNode("", true),
    (props.propShowBtnSaveFocusedInstitutional)
      ? (_openBlock(), _createBlock(BtnSaveFocusedInstitutional, {
          key: 5,
          accordionRef: props.accordionRef
        }, null, 8, ["accordionRef"]))
      : _createCommentVNode("", true),
    (props.propShowBtnDeleteSelectedCampaigns)
      ? (_openBlock(), _createBlock(BtnDeleteSelectedInstitutional, { key: 6 }))
      : _createCommentVNode("", true),
    (props.propShowBtnReviewFocusedCampaign)
      ? (_openBlock(), _createBlock(BtnReviewFocusedInstitutional, {
          key: 7,
          accordionRef: props.accordionRef
        }, null, 8, ["accordionRef"]))
      : _createCommentVNode("", true),
    (props.propShowBtnRequestAdjustmentsToFocusedInstitutional)
      ? (_openBlock(), _createBlock(BtnRequestAdjustmentsToFocusedInstitutional, { key: 8 }))
      : _createCommentVNode("", true),
    (props.propShowBtnSendFocusedInstitutionalToApprove)
      ? (_openBlock(), _createBlock(BtnSendFocusedInstitutionalToApprove, { key: 9 }))
      : _createCommentVNode("", true),
    (props.propShowBtnResendFocusedInstitutionalToApprove)
      ? (_openBlock(), _createBlock(BtnResendFocusedInstitutionalToApprove, {
          key: 10,
          accordionRef: __props.accordionRef
        }, null, 8, ["accordionRef"]))
      : _createCommentVNode("", true),
    (props.propShowBtnApproveFocusedInstitutional)
      ? (_openBlock(), _createBlock(BtnApproveFocusedInstitutional, { key: 11 }))
      : _createCommentVNode("", true),
    (props.propShowBtnPublishFocusedInstitutional)
      ? (_openBlock(), _createBlock(BtnPublishFocusedInstitutional, { key: 12 }))
      : _createCommentVNode("", true),
    (props.propShowBtnViewCampaignDistribution)
      ? (_openBlock(), _createBlock(BtnViewInstitutionalDistribution, { key: 13 }))
      : _createCommentVNode("", true)
  ]))
}
}

})